// Lo que dicen las tarjetas del asistente sobre este módulo, en los cuatro
// idiomas: `documents.assistant.*`. El backend manda la clave y el texto en
// inglés (§16, backend/assistant.js); la tarjeta lo dice en el idioma de quien
// la lee. Aparte de index.js porque es un contrato con ese fichero y no copia de
// una pantalla: una clave que se cambia aquí se cambia allí.

export default {
  es: {
    folder: {
      summary: {
        top: 'Crear la carpeta «{name}» en la raíz de los documentos',
        inside: 'Crear la carpeta «{name}» dentro de {parent}',
        elsewhere: 'Crear la carpeta «{name}» dentro de otra carpeta',
      },
      action: 'Crear una carpeta',
      field: { name: 'Nombre', parent: 'Dentro de' },
      value: { top: 'La raíz de los documentos', unknown: 'Otra carpeta' },
      where: 'Carpeta',
      outcome: 'Carpeta «{name}» creada',
    },
    move: {
      summary: {
        top: 'Mover «{document}» a la raíz de los documentos',
        into: 'Mover «{document}» a {folder}',
        elsewhere: 'Mover «{document}» a otra carpeta',
        unknownTop: 'Mover un documento a la raíz de los documentos',
        unknownInto: 'Mover un documento a otra carpeta',
      },
      action: 'Mover un documento',
      field: { document: 'Documento', from: 'Desde', to: 'A' },
      value: { unknown: 'Un documento que quizá no puedas abrir' },
      where: 'Documento',
      outcome: '«{document}» movido a {folder}',
    },
  },
  ca: {
    folder: {
      summary: {
        top: 'Crear la carpeta «{name}» a l’arrel dels documents',
        inside: 'Crear la carpeta «{name}» dins de {parent}',
        elsewhere: 'Crear la carpeta «{name}» dins d’una altra carpeta',
      },
      action: 'Crear una carpeta',
      field: { name: 'Nom', parent: 'Dins de' },
      value: { top: 'L’arrel dels documents', unknown: 'Una altra carpeta' },
      where: 'Carpeta',
      outcome: 'Carpeta «{name}» creada',
    },
    move: {
      summary: {
        top: 'Moure «{document}» a l’arrel dels documents',
        into: 'Moure «{document}» a {folder}',
        elsewhere: 'Moure «{document}» a una altra carpeta',
        unknownTop: 'Moure un document a l’arrel dels documents',
        unknownInto: 'Moure un document a una altra carpeta',
      },
      action: 'Moure un document',
      field: { document: 'Document', from: 'Des de', to: 'A' },
      value: { unknown: 'Un document que potser no pots obrir' },
      where: 'Document',
      outcome: '«{document}» mogut a {folder}',
    },
  },
  en: {
    folder: {
      summary: {
        top: 'Create the folder “{name}” at the top of the documents',
        inside: 'Create the folder “{name}” inside {parent}',
        elsewhere: 'Create the folder “{name}” inside another folder',
      },
      action: 'Create a folder',
      field: { name: 'Name', parent: 'Inside' },
      value: { top: 'The top of the documents', unknown: 'Another folder' },
      where: 'Folder',
      outcome: 'Folder “{name}” created',
    },
    move: {
      summary: {
        top: 'Move “{document}” to the top of the documents',
        into: 'Move “{document}” into {folder}',
        elsewhere: 'Move “{document}” into another folder',
        unknownTop: 'Move a document to the top of the documents',
        unknownInto: 'Move a document into another folder',
      },
      action: 'Move a document',
      field: { document: 'Document', from: 'From', to: 'To' },
      value: { unknown: 'A document you may not be able to open' },
      where: 'Document',
      outcome: '“{document}” moved to {folder}',
    },
  },
  fr: {
    folder: {
      summary: {
        top: 'Créer le dossier « {name} » à la racine des documents',
        inside: 'Créer le dossier « {name} » dans {parent}',
        elsewhere: 'Créer le dossier « {name} » dans un autre dossier',
      },
      action: 'Créer un dossier',
      field: { name: 'Nom', parent: 'Dans' },
      value: { top: 'La racine des documents', unknown: 'Un autre dossier' },
      where: 'Dossier',
      outcome: 'Dossier « {name} » créé',
    },
    move: {
      summary: {
        top: 'Déplacer « {document} » à la racine des documents',
        into: 'Déplacer « {document} » dans {folder}',
        elsewhere: 'Déplacer « {document} » dans un autre dossier',
        unknownTop: 'Déplacer un document à la racine des documents',
        unknownInto: 'Déplacer un document dans un autre dossier',
      },
      action: 'Déplacer un document',
      field: { document: 'Document', from: 'De', to: 'Vers' },
      value: { unknown: 'Un document que vous ne pouvez peut-être pas ouvrir' },
      where: 'Document',
      outcome: '« {document} » déplacé dans {folder}',
    },
  },
}
